import { Component, OnInit, TemplateRef } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { Alert_Interface } from './Interface/Alert_Interface';
import { Behfa_Interface } from './Interface/Behfa_Interface';
import { Customer_List_Interface } from './Interface/Customer_List_Interface';
import { General_Interface } from './Interface/General_Interface';
import { Empty_Nav_Interface, Nav_Interface } from './Interface/Nav_Interface';
import { AlertService } from './Service/Alert/Alert.service';
import { AlertifyService } from './Service/Alertify.service';
import { CustomerService } from './Service/Customer/Customer.service';
import { DevicepersianService } from './Service/Devicepersian/Devicepersian.service';
import { GeneralService } from './Service/General/General.service';
import { HelpService } from './Service/Help/Help.service';
import { LoginService } from './Service/Login/Login.service';
import { UserService } from './Service/User/User.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  Token: any;
  TokenStationTimer: any;
  Fullname: any;
  Type: any;
  BaserUrlImage: string = environment.BaseUrl
  BaseUrl = environment.BaseUrl

  nowClock: Date = new Date();
  nowDate: any;

  constructor(
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private login_Service: LoginService,
    private General_Service: GeneralService,
    private Help_Service: HelpService,
    private Alert_Service: AlertService,
    private Customer_Service: CustomerService,
    private Devicepersian_Service: DevicepersianService,
    private User_Service: UserService,
    private router: Router
  ) {



  }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Fullname = localStorage.getItem('Daro_User_Fullname');
    this.Type = localStorage.getItem('Daro_User_Type');
    this.BaserUrlImage = this.BaserUrlImage + localStorage.getItem('Daro_User_UserImage')
    if (this.Token) {
      this.Token_Station_Remain = 20 * 60


      this.General_Service.GetFullDate(this.Token).subscribe(
        data => {

          this.nowDate = data['fulldate']
          this.Read_Alert()
        }
      )

      setInterval(() => {
        this.nowClock = new Date();
        this.Read_Comment()
      }, 1000);



      this.Check_Token_Station()
      this.Time_Token_Station()

      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {

          if (!this.Check_Token_Station_Proccessing) {
            this.Check_Token_Station_Proccessing=true
            this.login_Service.SubmitUrl(this.router.url, this.Token).subscribe(
              data => {
                this.Check_Token_Station_Proccessing=false
              }, error => {
                this.Check_Token_Station_Proccessing=false
              }
            )
          }
        }
    });

    }


  }

  OnExit() {
    this.login_Service.Exit(this.Token).subscribe(
      data => {
        localStorage.clear()
        location.reload();
        clearInterval(this.TokenStationTimer);
        this.Token=""
      }, error => {
        localStorage.clear()
        location.reload();
        clearInterval(this.TokenStationTimer);
        this.Token=""
      }
    )

  }



  //#region Help

  Help_Proccessing: boolean = false
  modalRef_Help: any;
  Select_Record_Help: Array<Behfa_Interface> = []
  Help_Nav_Title: String = ''
  OnShowHelp(template: TemplateRef<any>) {
    this.Select_Record_Help = []
    this.Help_Nav_Title = ''
    this.Help_Proccessing = true

    var tempURL = this.router.url
    if (tempURL.indexOf(";") > -1) {
      tempURL = tempURL.substring(0, tempURL.indexOf(";"))
    }

    this.Help_Service.GetRecordUrl(this.Token, tempURL).subscribe(
      data => {
        this.Help_Proccessing = false
        this.modalRef_Help = this.modalService.show(template);
        this.Select_Record_Help = data['result']
        if (!data['menu']['title']) {
          this.Help_Nav_Title = 'Dashboard Menu Guide'
        }
        else {
          this.Help_Nav_Title = data['menu']['title'] + ' Menu Guide'
        }
      }
    )
  }

  //#endregion

  //#region Password

  modalRef_ResetPassword: any;

  CurrentPassword: string = ''
  NewPassword: string = ''
  NewRePassword: string = ''

  ProccesingPassword: boolean = false

  openModalPassword(template: TemplateRef<any>) {
    this.modalRef_ResetPassword = this.modalService.show(template);
  }

  ResetPassword() {
    if (!this.CurrentPassword) {
      this.Alertify_Service.ErrorMessage("Please enter your current password")
    }
    else if (this.NewPassword.length < 6) {
      this.Alertify_Service.ErrorMessage("The new password must contain at least six characters")
    }
    else if (this.NewPassword != this.NewRePassword) {
      this.Alertify_Service.ErrorMessage("The new password and confirmation do not match")
    }
    else {
      this.ProccesingPassword = true
      this.login_Service.ResetPassword(this.CurrentPassword, this.NewPassword, this.Token).subscribe(
        data => {
          this.ProccesingPassword = false
          if (!data['token']) {
            this.Alertify_Service.ErrorMessage("The current password is incorrect")
          }
          else {
            this.Alertify_Service.SuccessMessage("The password was changed successfully")
            this.CurrentPassword = ""
            this.NewPassword = ""
            this.NewRePassword = ""
          }
        }
      )
    }
  }

  //#endregion

  //#region Comment


  Comment_Url_Show = ["/LetterRequestCustomerForm",
    "/CalibrationInPositionForm",
    "/CalibrationReception",
    "/KartableInbox"]

  Comment_Show_Button: boolean = false
  Comment_Customer_Id: string = ""

  Comment_Proccessing: boolean = false
  modalRef_Comment: any;
  Select_Record_Comment: Array<any> = []

  Comment_Nav_Title: String = ''
  Comment_Nav_Form_Title: String = ''
  Comment_Nav_Form_Dsc: String = ''

  OnShowComment(template: TemplateRef<any>) {
    this.Select_Record_Comment = []
    this.Comment_Nav_Title = ''
    this.Comment_Nav_Form_Title = ''
    this.Comment_Proccessing = true

    var tempCustomer: Customer_List_Interface = JSON.parse(this.Comment_Customer_Id)



    this.Customer_Service.GetCustomerComment(this.Token, tempCustomer.id,0).subscribe(
      data => {
        this.Comment_Proccessing = false
        this.modalRef_Comment = this.modalService.show(template);
        this.Select_Record_Comment = data
        this.Comment_Nav_Title = ' Customer Comments: ' + tempCustomer.name
        this.Comment_Nav_Form_Title = ' Register a New Comment for Customer: ' + tempCustomer.name
      }
    )
  }

  Read_Comment() {

    this.Comment_Show_Button = false

    var tempURL = this.router.url
    if (tempURL.indexOf(";") > -1) {
      tempURL = tempURL.substring(0, tempURL.indexOf(";"))
    }
    for (let item of this.Comment_Url_Show) {

      if (item == tempURL) {
        this.Comment_Show_Button = true
        break;
      }

    }

    for (let item of this.DevicePersianEngHelp_Url_Show) {

      var tempURL = this.router.url
      if (tempURL.indexOf(";") > -1) {
        tempURL = tempURL.substring(0, tempURL.indexOf(";"))
      }

      if (item == tempURL) {
        this.DevicePersianEngHelp_Show_Button = true
        break;
      }

    }

    this.Comment_Customer_Id = localStorage.getItem('Daro_User_Comment');
    this.Comment_Show_Button = this.Comment_Show_Button && (this.Comment_Customer_Id != null)
  }

  Submit_Comment() {
    if (!this.Comment_Nav_Form_Dsc) {
      this.Alertify_Service.ErrorMessage("Please enter a description")
    }
    else {
      this.Comment_Proccessing = true
      var tempCustomer: Customer_List_Interface = JSON.parse(this.Comment_Customer_Id)

      this.Customer_Service.AddComment(this.Comment_Nav_Form_Dsc,tempCustomer.id, this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The comment was registered successfully")
          this.Comment_Proccessing = false
          this.Comment_Nav_Form_Dsc = ''
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )
    }
  }



  //#endregion

  //#region Token Station
  Token_Station_Proccessing: boolean = false
  Check_Token_Station_Proccessing: boolean = false
  Token_Station_Remain: number = 0
  onlineUser: Array<any> = []
  modalRef_onlineUser:any

  Check_Token_Station() {
    setInterval(() => {
      if (!this.Check_Token_Station_Proccessing) {
        this.Check_Token_Station_Proccessing=true
        this.login_Service.GetTokenStation(this.Token).subscribe(
          data => {
            this.Check_Token_Station_Proccessing=false
            localStorage.setItem('Daro_User_TokenStation', String(data['second']));
            this.Token_Station_Remain = data['second']
            this.onlineUser = data['onlineUser']
          }
        )
      }

    }, 15000);
  }

  OnShow_onlineUser(template: TemplateRef<any>) {
    this.modalRef_onlineUser = this.modalService.show(template);
  }

  Time_Token_Station() {
    this.Token_Station_Remain = Number(localStorage.getItem('Daro_User_TokenStation'));

    this.TokenStationTimer = setInterval(() => {
      if (this.Token_Station_Remain <= 0) {
        this.Token_Station_Remain = 0
        this.OnExit()
      }
      else {
        this.Token_Station_Remain = this.Token_Station_Remain - 1
        localStorage.setItem('Daro_User_TokenStation', String(this.Token_Station_Remain));

      }

    }, 1000);
  }

  ExtensionTokenStation() {
    this.Token_Station_Proccessing = true
    this.login_Service.ExtensionTokenStation(this.Token).subscribe(
      data => {
        this.Token_Station_Proccessing = false
        this.Token_Station_Remain = 20 * 60
      }, error => {
        localStorage.clear()
        location.reload();
        clearInterval(this.TokenStationTimer);
      }
    )
  }

  UserUrl_Min_Month:string=''
  UserUrl_Min_YesterDay:string=''
  GetLogingUrlUser() {
    this.User_Service.GetLogingUrlUser(this.Token).subscribe(
      data => {
        this.UserUrl_Min_Month=data['month']
        this.UserUrl_Min_YesterDay=data['yesterday']
      }
    )
  }

  //#endregion

  //#region Alert
  DataList_Alert: Array<Alert_Interface> = []
  Read_Alert() {

    var tempURL = this.router.url
    if (tempURL.indexOf(";") > -1) {
      tempURL = tempURL.substring(0, tempURL.indexOf(";"))
    }


    this.Alert_Service.GetActive(this.Token).subscribe(
      data => {

        if (tempURL != '/Dashboard') {
          for (let item of data) {
            item.del = true;
          }
        }

        this.DataList_Alert = data

        this.GetLogingUrlUser()
      }
    )
  }

  Show_All_Alerm() {
    for (let item of this.DataList_Alert) {
      item.del = false;
    }
  }

  See_Alert(item: Alert_Interface) {
    item.del = true
  }

  //#endregion

  //#region DevicePersianEngHelp

  DevicePersianEngHelp_Url_Show = ["/LetterRequestCustomerCalibration"]

  Select_Record_DevicePersianEngHelp: Array<any> = []
  modalRef_DevicePersianEngHelp: any;
  key_DevicePersianEngHelp: string = '';
  DevicePersianEngHelp_Show_Button: boolean = false
  DevicePersianEngHelp_Proccessing: boolean = false


  OnShow_DevicePersianEngHelp(template: TemplateRef<any>) {
    this.modalRef_DevicePersianEngHelp = this.modalService.show(template);
  }

  Read_DevicePersianEngHelp() {
    this.DevicePersianEngHelp_Proccessing = true
    this.Devicepersian_Service.GetDevicePersianEngHelp(this.Token, this.key_DevicePersianEngHelp).subscribe(
      data => {
        this.Select_Record_DevicePersianEngHelp = data
        this.DevicePersianEngHelp_Proccessing = false
      },
      error => {
        this.DevicePersianEngHelp_Proccessing = false
      }
    )
  }


  //#endregion

}
